<template>
  <div>已跳转中厚板车辆监控页面，请在新页面查看</div>
</template>
<script>
export default {
  data () {
    return {

    }
  },
  created () {
    this.tiaoZhuan()
  },
  methods: {
    tiaoZhuan () {
      // window.open('http://any.zw56.com/#/zhb-dp/zhbfinished')
      window.open('http://any.zw56.com/#/zhb-dp/zhbMonitor')
    }
  }
}
</script>
<style>

</style>
